var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#303030",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19702 3.46967C7.48991 3.76256 7.48991 4.23744 7.19702 4.53033L4.47735 7.25H9.66669C10.0809 7.25 10.4167 7.58579 10.4167 8C10.4167 8.41421 10.0809 8.75 9.66669 8.75H4.47735L7.19702 11.4697C7.48991 11.7626 7.48991 12.2374 7.19702 12.5303C6.90412 12.8232 6.42925 12.8232 6.13636 12.5303L2.13636 8.53033C1.84346 8.23744 1.84346 7.76256 2.13636 7.46967L6.13636 3.46967C6.42925 3.17678 6.90412 3.17678 7.19702 3.46967ZM10.9167 8C10.9167 7.58579 11.2525 7.25 11.6667 7.25H13.3334C13.7476 7.25 14.0834 7.58579 14.0834 8C14.0834 8.41421 13.7476 8.75 13.3334 8.75H11.6667C11.2525 8.75 10.9167 8.41421 10.9167 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.c13419eb.svg";
export { ForwardRef as ReactComponent };